import { render, staticRenderFns } from "./OfertaFoto.vue?vue&type=template&id=f0c84aaa&"
import script from "./OfertaFoto.vue?vue&type=script&lang=js&"
export * from "./OfertaFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports